import React from 'react';
import { useNavigate } from 'react-router-dom';

const OrderConfirmation = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-[82vh] bg-[#f8f4f3] flex flex-col items-center justify-center text-center px-4">
      <img
        src="https://cdn-icons-png.flaticon.com/512/845/845646.png"
        alt="Success"
        className="w-20 h-20 mb-4"
      />
      <h1 className="text-2xl font-bold">Your order is placed</h1>
      <p className="text-gray-600 mt-2">Thank you for your payment.</p>
      <p className="text-gray-600 mb-6">Order invoice sent to your email.</p>
      <button
        onClick={handleBackToHome}
        className="bg-red-500 text-white px-5 py-2 rounded hover:bg-red-600 transition"
      >
        BACK TO HOME
      </button>
    </div>
  );
};

export default OrderConfirmation;
